<template>
  <q-dialog
    :value="isOpen"
    @hide="handleClick"
  >
    <q-card>
      <div class="flex row q-pa-sm q-mx-sm justify-center items-center header">
        <Icon
          name="error"
          class-name="size-18"
        />
        <span class="q-ml-sm">Atenção</span>
      </div>

      <div class="flex column q-pa-sm">
        <span>{{ String(error || '').translate() }}</span>
        <q-btn
          data-testid="erro-ok"
          @click="handleClick"
          class="bg-grey-4 q-mt-sm button"
          label="Ok"
        />
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  components: {
    Icon
  },

  computed: {
    isOpen () {
      return Boolean(this.error)
    }
  },

  props: {
    error: {
      type: String
    }
  },

  methods: {
    handleClick () {
      this.$emit('on-close')
    }
  }
}
</script>
<style lang="sass" scoped>
  button
    width: 56px
    heigth: 16px
    margin-left: auto

  span
    font-size: 14px
    font-weight: 300
    line-height: 16px

  .header
    border-bottom: 1px solid #eee
</style>
